export const NATTER_EXPLAINER_VIDEO =
  window._env_?.VITE_APP_NATTER_EXPLAINER_VIDEO_URL ?? 'https://asset.app.natter.co/attachments/Natter_Promo_v5.mp4';

export const NATTER_EXPLAINER_VIDEO_CAPTIONS =
  window._env_?.VITE_APP_NATTER_EXPLAINER_VIDEO_CAPTIONS_URL ??
  'https://asset.app.natter.co/attachments/Open_Natter_Promo_v3.vtt';

/**
 * Poster still for the explainer video, derived from the video URL by swapping the extension
 * (`Natter_Promo_v5.mp4` -> `Natter_Promo_v5.jpg`), so it can never point at a different
 * version than the video it fronts. Generate it with `pnpm make:explainer-poster` and upload
 * it next to the mp4. iOS refuses to fetch any video data before the first tap, so without a
 * poster the player renders as an empty box there.
 */
export const explainerVideoPosterUrl = (videoUrl: string): string | undefined =>
  /\.mp4$/i.test(videoUrl) ? videoUrl.replace(/\.mp4$/i, '.jpg') : undefined;

export const NATTER_EXPLAINER_VIDEO_POSTER = explainerVideoPosterUrl(NATTER_EXPLAINER_VIDEO);
